/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setOpenModales } from '../../store/global';
import { isEditable } from '../../utils/roles';
import { PicSettings } from './pic.Settings';
import { fetchImage } from '../../utils/img';
import { renderIconBySlug } from '../../content/icons';
import { getAvatarBackgroundStyle } from '../../utils/item';

export const PicGlobal = props => {
  const { itemId, picId, pic, fieldInGrid, masonry, canEdit = true } = props;

  const picRef = useRef(null);
  const dispatch = useDispatch();

  const [loadedPic, setLoadedPic] = useState(null);
  const hasIcon = Boolean(pic?.iconSlug);
  const iconElement = useMemo(() => {
    if (!pic?.iconSlug) {
      return null;
    }
    return renderIconBySlug(pic.iconSlug, {
      size: 72,
      color: 'var(--contrast)',
    });
  }, [pic?.iconSlug]);

  useEffect(() => {
    if (picRef?.current) {
      picRef.current.style.height = '100%';
      picRef.current.style.width = '100%';
      const height = picRef.current.offsetHeight;
      const width = picRef.current.offsetWidth;
      const minSize = Math.min(height, width);
      picRef.current.style.height = minSize + 'px';
      picRef.current.style.width = minSize + 'px';
    }
  }, [picRef?.current, fieldInGrid]);

  useEffect(() => {
    if (pic?.iconSlug && !pic?.url) {
      setLoadedPic(null);
      return;
    }
    if (pic?.url) {
      fetchImage(pic.url, setLoadedPic);
    } else {
      setLoadedPic(null);
    }
  }, [pic?.url, pic?.iconSlug]);

  const bgStyle = useMemo(
    () => getAvatarBackgroundStyle(pic?.bgColor),
    [pic?.bgColor]
  );
  const imageStyle = useMemo(() => {
    const base = loadedPic
      ? {
          backgroundImage: `url(${loadedPic})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }
      : {};
    return { ...bgStyle, ...base };
  }, [loadedPic, bgStyle]);

  const renderVisualBlock = className => {
    if (hasIcon) {
      return (
        <div
          className={`${className} flex items-center justify-center text-contrast text-opacity-90`}
          style={bgStyle}
        >
          {iconElement}
        </div>
      );
    }
    return (
      <div
        className={className}
        style={imageStyle}
      ></div>
    );
  };

  if (!fieldInGrid && masonry) {
    return (
      <div
        className='rounded bg-main overflow-hidden flex justify-center items-center w-full h-full'
        onDoubleClick={e => {
          e.stopPropagation();
          isEditable() &&
            canEdit &&
            dispatch(setOpenModales({ id: picId, open: true }));
        }}
      >
        <PicSettings
          picId={picId}
          itemId={itemId}
          pic={pic}
        />
        {hasIcon ? (
          <div
            className='text-5xl text-contrast text-opacity-80 flex items-center justify-center w-full h-full'
            style={bgStyle}
          >
            {iconElement}
          </div>
        ) : loadedPic ? (
          <img
            src={loadedPic}
            alt='pic'
          />
        ) : (
          <div className='w-full h-full bg-main bg-opacity-20'></div>
        )}
      </div>
    );
  } else {
    return (
      <div
        className='w-full h-full'
        onDoubleClick={e => {
          e.stopPropagation();
          isEditable() &&
            canEdit &&
            dispatch(setOpenModales({ id: picId, open: true }));
        }}
      >
        <PicSettings
          picId={picId}
          itemId={itemId}
          pic={pic}
        />
        {(fieldInGrid?.displayType === 'arrondi' ||
          fieldInGrid?.displayType === 'pics' ||
          !fieldInGrid) && (
          <div className='p-05 w-full h-full'>
            {renderVisualBlock('w-full h-full rounded shadow')}
          </div>
        )}
        {fieldInGrid?.displayType === 'pleine largeur' && (
          <div className='w-full h-full'>
            {renderVisualBlock('w-full h-full')}
          </div>
        )}
        {fieldInGrid?.displayType === 'rond' && (
          <div className='p-1 w-full h-full flex justify-center items-center'>
            {hasIcon ? (
              <div
                ref={picRef}
                className='w-full h-full rounded-full shadow flex items-center justify-center text-contrast text-opacity-90'
                style={bgStyle}
              >
                {iconElement}
              </div>
            ) : (
              <div
                ref={picRef}
                className='w-full h-full rounded-full shadow'
                style={imageStyle}
              ></div>
            )}
          </div>
        )}
      </div>
    );
  }
};
